module.exports = __webpack_public_path__ + "static/vo-3725b71202925b9c228b93de847da022.mp3";